import { getIssueKey } from '@jira/router-resources__utils/src/getIssueKey.tsx';
import { browserOnlyResourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import getIssueViewRemoteData from './getIssueViewRemoteData.tsx';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const issueViewRemoteDataResource: RouteResource<any> = browserOnlyResourceWithCondition(
	() => {
		return !fg('dfo_issue_view_remote_data_srr_group');
	},
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	createResource<any>({
		type: 'ISSUE_VIEW_REMOTE_DATA',
		getKey: ({ match }) => {
			const issueKey = getIssueKey(match);
			return issueKey || '';
		},
		getData: (...args) => getIssueViewRemoteData(...args),
		isBrowserOnly: true,
	}),
);
